/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";

export const useModalStore = defineStore({
  id: "modal",
  state: () => ({
    actionModal: {
      toShow: false,
      options: {
        title: "",
        text: "",
        primaryBtnText: null,
        primaryBtnAction: null,
        secondaryBtnText: null,
        secondaryBtnAction: null,
        alignment: {},
      },
    },

    walletModal: {
      toShow: false,
      options: {
        primaryBtnAction: null,
        secondaryBtnAction: null,
        alignment: {},
      },
    },

    successModal: { toShow: false, progressLevel: "" },
  }),
  actions: {},
  getters: {
    getActionModalData(store) {
      return store.actionModal;
    },
    getSuccessModalVisibility(store) {
      return store.successModal.toShow;
    },
    showModal() {},
  },
});
